import { autoMount } from '../../../utils/autoMount';
import { EventDetail } from '../../../components/pages/eventDetail';

autoMount({ EventDetail });
